// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetIsAuditLoaded = () => getDefaultState().isAuditLoaded;

const updateIsAuditLoaded = (state, action) => action.isAuditLoaded;

export default (state = getDefaultState().isAuditLoaded, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_PREPARE_AUDIT_AUDIT]: resetIsAuditLoaded,
        [actions.UPDATE_TCSM_PREPARE_AUDIT_IS_AUDIT_LOADED]: updateIsAuditLoaded
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/reducers/is-audit-loaded.js